<div class="row entry-row">
  <div class="col-12 col-sm-auto">
    <h3 class="content-header-title">{{ '::Menu:Home' | abpLocalization }}</h3>
  </div>
</div>
<div class="card home-page">
  <div class="card-header pb-0 text-center">
    <h1 class="mb-0">Knovvu ML</h1>
  </div>
  <div class="card-body text-center">
    <div *ngIf="hasLoggedIn">
      <p class="mb-2">{{ '::WelcomeSestekAIMessageWithLogin' | abpLocalization }}</p>
      <div class="row">
        <div class="col mb-1" *abpPermission="'SestekAI.Projects'">
          <a [routerLink]="['projects']">
            <div class="box border rounded p-2 pt-4 pb-4 text-center c-pointer">
              <h4>{{ '::Menu:Projects' | abpLocalization }}</h4>
              <aside class="icon">
                <i class="fa fa-file-alt"></i>
              </aside>
            </div>
          </a>
        </div>
        <div class="col mb-1" *abpPermission="'SestekAI.PublishedModels'">
          <a [routerLink]="['published-model']">
            <div class="box border rounded p-2 pt-4 pb-4 text-center c-pointer">
              <h4>{{ '::Menu:PublishedModels' | abpLocalization }}</h4>
              <aside class="icon">
                <i class="fas fa-file-alt"></i>
              </aside>
            </div>
          </a>
        </div>
        <div class="col mb-1" *abpPermission="'SestekAI.PublicEndpoints'">
          <a [routerLink]="['/public-endpoint']">
            <div class="box border rounded p-2 pt-4 pb-4 text-center c-pointer">
              <h4>{{ '::Menu:PublicEndpoints' | abpLocalization }}</h4>
              <aside class="icon">
                <i class="fas fa-file-alt"></i>
              </aside>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
